/* Aviso de ubicación: decide si proponer cambiar de país y da los textos en el idioma del país detectado. */
(function (root) {
  var IDIOMA = { DE: 'de', ES: 'es', FR: 'fr' };
  var NOMBRES = {
    es: { DE: 'Alemania', ES: 'España', FR: 'Francia' },
    de: { DE: 'Deutschland', ES: 'Spanien', FR: 'Frankreich' },
    en: { DE: 'Germany', ES: 'Spain', FR: 'France' },
    fr: { DE: 'Allemagne', ES: 'Espagne', FR: 'France' }
  };
  var T = {
    es: { titulo: 'Parece que estás en {pais}.', pregunta: '¿Ver precios y envío para {pais}?', si: 'Sí, cambiar', no: 'No, seguir aquí' },
    de: { titulo: 'Es sieht so aus, als wärst du in {pais}.', pregunta: 'Preise und Lieferung für {pais} anzeigen?', si: 'Ja, wechseln', no: 'Nein, hier bleiben' },
    en: { titulo: "It looks like you're in {pais}.", pregunta: 'See prices and shipping for {pais}?', si: 'Yes, switch', no: 'No, stay here' },
    fr: { titulo: 'Il semble que vous soyez en {pais}.', pregunta: 'Voir les prix et la livraison pour {pais} ?', si: 'Oui, changer', no: 'Non, rester ici' }
  };

  function decidir(o) {
    if (!o || !o.detectado || o.respondido) return null;
    if (o.detectado === o.actual) return null;
    if (!o.disponibles || o.disponibles.indexOf(o.detectado) === -1) return null;
    return { pais: o.detectado };
  }

  function textos(lang, pais) {
    var l = T[lang] ? lang : 'en';
    var nombre = (NOMBRES[l] && NOMBRES[l][pais]) || pais;
    var out = {};
    Object.keys(T[l]).forEach(function (k) { out[k] = T[l][k].replace('{pais}', nombre); });
    return out;
  }

  var api = { decidir: decidir, textos: textos, idiomaDe: function (pais) { return IDIOMA[pais] || 'en'; } };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.CDA_GEO = api;
})(typeof window !== 'undefined' ? window : globalThis);
